import { contactUs } from "core/services/api";
import React, { useEffect, useState } from "react"
import "./ContactsPage.scss"

export default function ContactsPage() {
  // const contactsInfo = [
  //   {
  //     center: "Ghatkopar",
  //     mobileNumbers: ["+91 9987899700 ", "+912221020017", "+919769707204"],
  //   },
  //   {
  //     center: "Thane",
  //     mobileNumbers: ["+91 9167236796", "02225301090", "+91 7400424333"],
  //   },
  //   { center: "Borivali", mobileNumbers: ["+919920767628", "+917506128787"] },
  //   {
  //     center: "Vile parle",
  //     mobileNumbers: ["+919833662891", "+918879026609"],
  //   },
  //   { center: "Pune", mobileNumbers: ["+919769771595", "+919769773595"] },
  //   { center: "Sion", mobileNumbers: ["+919769861787", "+917677434237"] },
  //   { center: "Malad", mobileNumbers: ["+91 9920767626", "+91 7506128787"] },
  // ]

  const [contactsInfo, setContactsInfo] = useState<any>();

  useEffect(() => {
    contactUs().then((res: any) => {
      console.log(res, "contactus")
      setContactsInfo(res)
    })

  }, [])
  return (
    <div className="contacts-page-wrapper">
      <div className="header-text">Contact Us</div>

      <div className="numbers-section col-6">
        {contactsInfo?.map((eachContact: any) => (
          <div className="d-flex col-12 contact-info">
            <div className="section-header col-4 p-0">
              {eachContact?.centerName} :
            </div>
            <div className="col-8 p-0">
              {eachContact?.contactNumber}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
